import { trace } from 'owa-trace';
import type { Suggestion } from 'owa-userdataservice';
import {
    SonoraEntityType,
    SonoraFile,
    SonoraFileSuggestionSourceType,
} from 'owa-editor-sonora-types';

const FILE_KEY_NAME = 'File';
const MAX_FILE_COUNT = 5;

export default function parseVivaTopicFileSuggestions(
    suggestion: Suggestion
): SonoraFile[] | undefined {
    try {
        const data = JSON.parse(suggestion.encodedJsonData);

        // There may be multiple topics, and each topic has its own set of related files.
        const suggestions: SonoraFile[] = [];
        if (data?.Value) {
            data.Value.forEach(userDataInfo => {
                if (userDataInfo.RelatedResourcesMap?.length > 0) {
                    userDataInfo.RelatedResourcesMap.forEach(relatedResourcesMap => {
                        if (relatedResourcesMap.Key === FILE_KEY_NAME) {
                            relatedResourcesMap.Value.forEach(file =>
                                suggestions.push(<SonoraFile>{
                                    type: SonoraEntityType.VivaTopicFile,
                                    sourceType: SonoraFileSuggestionSourceType.SharepointOnline,
                                    fileName: file.Title,
                                    url: file.Url,
                                    fileExtension: file.Extension,
                                    lastModifiedDateTime: file.LastModifiedTime,
                                    relatedTopicName: userDataInfo.DisplayName,
                                })
                            );
                        }
                    });
                }
            });

            // Don't go beyond 5 files for Topics.
            // In getDataProviderToSuggestionsDictionary we also check the file limit.
            // Temporary design until we have final design in place.
            return suggestions.slice(0, MAX_FILE_COUNT);
        }
    } catch (error) {
        trace.warn(`[HoneybeeSonora|parseVivatopicFileSuggestions] Error: ${error}`);
    }
    return undefined;
}
